import React, {PureComponent} from 'react';
import {Button, ButtonGroup, ButtonToolbar} from 'reactstrap';
import {scientificToDecimal} from "../helpers/Utils";

class PercentButtonGroup extends PureComponent {
  onClickButton = percent => {
    const {amount, onChoosePercentage} = this.props;
    if (amount) {
      onChoosePercentage(scientificToDecimal((percent * amount) / 100));
    }
  };

  render() {
    return (
      <div className="percent-buttons-container">
        <ButtonToolbar className="w-100">
          <ButtonGroup size="sm" className="w-100 flex-row-reverse">
            <Button className="w-25 text-center" outline onClick={() => {this.onClickButton(25);}}>25%</Button>
            <Button className="w-25 text-center" outline onClick={() => {this.onClickButton(50);}}>50%</Button>
            <Button className="w-25 text-center" outline onClick={() => {this.onClickButton(75);}}>75%</Button>
            <Button className="w-25 text-center" outline onClick={() => {this.onClickButton(100);}}>100%</Button>
          </ButtonGroup>
        </ButtonToolbar>
      </div>
    );
  }
}

export default PercentButtonGroup;